"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.premiumBandLabel = exports.issueAgeBonusLabel = exports.formatPremiumBand = exports.formatIssueAgeBonus = exports.bestPremiumBonus = exports.normalizeProductType = exports.isProductType = exports.FIG_PRODUCT_TYPES = void 0;
var models_js_1 = require("./types/models.js");
Object.defineProperty(exports, "FIG_PRODUCT_TYPES", { enumerable: true, get: function () { return models_js_1.FIG_PRODUCT_TYPES; } });
Object.defineProperty(exports, "isProductType", { enumerable: true, get: function () { return models_js_1.isProductType; } });
Object.defineProperty(exports, "normalizeProductType", { enumerable: true, get: function () { return models_js_1.normalizeProductType; } });
var rate_bands_js_1 = require("./rate-bands.js");
Object.defineProperty(exports, "bestPremiumBonus", { enumerable: true, get: function () { return rate_bands_js_1.bestPremiumBonus; } });
Object.defineProperty(exports, "formatIssueAgeBonus", { enumerable: true, get: function () { return rate_bands_js_1.formatIssueAgeBonus; } });
Object.defineProperty(exports, "formatPremiumBand", { enumerable: true, get: function () { return rate_bands_js_1.formatPremiumBand; } });
Object.defineProperty(exports, "issueAgeBonusLabel", { enumerable: true, get: function () { return rate_bands_js_1.issueAgeBonusLabel; } });
Object.defineProperty(exports, "premiumBandLabel", { enumerable: true, get: function () { return rate_bands_js_1.premiumBandLabel; } });
__exportStar(require("./types/index.js"), exports);
//# sourceMappingURL=index.js.map